// extracted by mini-css-extract-plugin
export default {"note":"OfferNotes_note__ztpvV","content":"OfferNotes_content__8hBTc"};